/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { Dashboards } from './dashboards/index.tsx';
import { IssueViewModal } from './issue-view-modal/index.tsx';
import { KeyboardShortcuts } from './keyboard-shortcuts/index.tsx';
import { Projects } from './projects/index.tsx';

export function Integrations(): React.JSX.Element | null {
	if (!__SERVER__) {
		return (
			<>
				<IssueViewModal />
				<Projects />
				<Dashboards />
			</>
		);
	}
	return null;
}
// oxlint-disable-next-line typescript/no-namespace
export declare namespace Integrations {
	// eslint-disable-next-line import/no-mutable-exports, no-var
	export var displayName: string;
}
Integrations.displayName = 'Integrations'; // This is needed to pass the test.tsx's uniqueness-test. Without it, the component appears as 'ComponentWithCondition[]', which already exists in the list.

export function IntegrationsWhichRequireNavigationRoot(): React.JSX.Element | null {
	if (!__SERVER__) {
		return <KeyboardShortcuts />;
	}
	return null;
}
